import { useEffect } from 'react';

/**
 * Preloads critical resources to improve LCP and reduce blocking time
 * This component should be loaded as early as possible in the app
 */
export function PreloadCritical() {
  useEffect(() => {
    // Preload critical images for LCP optimization
    const criticalImages = [
      '/images/panama-city-skyline.jpg', // Hero image
      '/images/optimized/office/office-0.webp', // First office image
    ];

    criticalImages.forEach((src, index) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      
      // High priority for the first image (LCP candidate)
      if (index === 0) {
        link.setAttribute('fetchpriority', 'high');
      }
      
      document.head.appendChild(link);
    });

    // Preconnect to external domains
    const externalDomains = [
      'https://fonts.googleapis.com',
      'https://fonts.gstatic.com',
      'https://images.unsplash.com',
      'https://www.google-analytics.com',
      'https://www.googletagmanager.com'
    ];

    externalDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = domain;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    });

    // DNS prefetch for additional domains
    const dnsPrefetchDomains = [
      'https://cdn.jsdelivr.net',
      'https://unpkg.com'
    ];

    dnsPrefetchDomains.forEach(domain => {
      const link = document.createElement('link');
      link.rel = 'dns-prefetch';
      link.href = domain;
      document.head.appendChild(link);
    });

    // Preload critical CSS (if using external stylesheets)
    const criticalCSS: string[] = [
      // Add any critical external CSS files here
    ];

    criticalCSS.forEach(href => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'style';
      link.href = href;
      document.head.appendChild(link);
    });

    // Add resource hints meta tags
    const viewport = document.querySelector('meta[name="viewport"]');
    if (!viewport) {
      const meta = document.createElement('meta');
      meta.name = 'viewport';
      meta.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
      document.head.appendChild(meta);
    }

    // Optimize rendering
    const renderingMeta = document.createElement('meta');
    renderingMeta.httpEquiv = 'x-ua-compatible';
    renderingMeta.content = 'ie=edge';
    document.head.appendChild(renderingMeta);

  }, []);

  return null; // This component doesn't render anything
}

export default PreloadCritical;